// project import
import dashboard from './dashboard';
import routes from './routes';
import organization from './organization';
import partnerManagement from './partner-management';
import reports from './reports';
// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const adminMenuItems: { items: NavItemType[] } = {
    items: [dashboard, routes, partnerManagement, reports, organization]
};

export default adminMenuItems;